var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyPaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7857 8.00167V5.71596C19.7857 5.10975 19.5449 4.52837 19.1162 4.09972C18.6876 3.67106 18.1062 3.43025 17.5 3.43025H15.2143M9.5 24.0017H3.78571C3.17951 24.0017 2.59812 23.7609 2.16947 23.3322C1.74082 22.9035 1.5 22.3222 1.5 21.716V5.71596C1.5 5.10975 1.74082 4.52837 2.16947 4.09972C2.59812 3.67106 3.17951 3.43025 3.78571 3.43025H6.07143M19.7857 19.4302H26.6429M19.7857 24.0017H26.6429M28.9286 12.5731H17.5C16.8938 12.5731 16.3124 12.8139 15.8838 13.2426C15.4551 13.6712 15.2143 14.2526 15.2143 14.8588V28.5731C15.2143 29.1793 15.4551 29.7607 15.8838 30.1893C16.3124 30.618 16.8938 30.8588 17.5 30.8588H28.9286C29.5348 30.8588 30.1162 30.618 30.5448 30.1893C30.9735 29.7607 31.2143 29.1793 31.2143 28.5731V14.8588C31.2143 14.2526 30.9735 13.6712 30.5448 13.2426C30.1162 12.8139 29.5348 12.5731 28.9286 12.5731ZM15.7857 1.14453H5.5L6.43714 4.84739C6.49423 5.09522 6.63397 5.31625 6.83337 5.47411C7.03277 5.63197 7.27997 5.71726 7.53429 5.71596H13.7514C14.0058 5.71726 14.2529 5.63197 14.4523 5.47411C14.6517 5.31625 14.7915 5.09522 14.8486 4.84739L15.7857 1.14453Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyPaste);
export default __webpack_public_path__ + "static/media/copy-paste.f48d2226022a360d898b7086f3a6c00f.svg";
export { ForwardRef as ReactComponent };